import moment from 'moment';

export function subtractDaysFromDate(
  dateString: string,
  numberToSubstract: number,
  nominal: any = 'days',
): string {
  // Parse the date string using Moment.js
  //@ts-ignore
  const date = moment(dateString, 'YYYY-MM-DD HH:mm:ss');

  // Subtract the specified number of days
  const newDate = date.subtract(numberToSubstract, nominal);

  // Format the resulting date
  const formattedDate: string = newDate.format('YYYY-MM-DD HH:mm:ss');

  return formattedDate;
}

export const timeAgo = (dateString?: string | null): string => {
  if (!dateString) return 'never';
  const normalized = dateString.includes('T') ? dateString : dateString.replace(' ', 'T');
  const date = new Date(normalized);
  if (isNaN(date.getTime())) return dateString;

  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  // Less than 10 seconds or slight future clock skew
  if (seconds < 10) {
    return 'just now';
  }

  // Less than a minute
  if (seconds < 60) {
    return `${seconds}s ago`;
  }

  // Less than an hour
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes}m ago`;
  }

  // Less than a day
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours}h ago`;
  }

  // Days
  const days = Math.floor(hours / 24);
  if (days < 30) {
    return `${days}d ago`;
  }

  // Months
  const months = Math.floor(days / 30);
  if (months < 12) {
    return `${months}mo ago`;
  }

  // Years
  const years = Math.floor(days / 365);
  return `${years}y ago`;
};

export const generateDateRange = (start: Date, end: Date) => {
  const range: Date[] = [];
  const currentDate = new Date(start);

  while (currentDate <= end) {
    range.push(new Date(currentDate)); // push a copy
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return range;
};

export const formatMonth = (date: Date) => {
  return date.toLocaleString('default', { month: 'long' });
};

export const hours = Array.from({ length: 24 }, (_, i) => i);
